import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DealerCandidateRequest } from '../../../shared/interfaces/dealer.interfaces';

const basePath = '/dealer/candidate';

@Injectable({
  providedIn: 'root'
})

export class DealerCandidateService {
  constructor(private http: HttpClient) { }

  // Sends a new dealer request to Netio support email
  newDealerRequest(payload: DealerCandidateRequest) {
    const body = payload
    return this.http.post(`${basePath}`, body);
  }
}
